import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { DashboardComponent } from './dashboard/dashboard.component';
import { AddDealComponent } from './add-deal/add-deal.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { SgrbRoutingModule } from './sgrb-routing.module';



@NgModule({
  declarations: [
    DashboardComponent,
    AddDealComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    TimepickerModule,
    SgrbRoutingModule
  ]
})
export class SrgbModule { }
